import {
  type ModalProperties,
  type ModalScreen,
  toModalProperties
} from '~/utils/modalProperties';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type RegistrationPlacement =
  | 'coming_soon_gate'
  | 'crepe_city_welcome'
  | 'email_confirmation'
  | 'gated_card'
  | 'gated_listing'
  | 'header'
  | 'notify_me'
  | 'password_reset'
  | 'profile_page'
  | 'raffle_gate'
  | 'sole_market_buy_now';

export type RegistrationMethod =
  | 'apple'
  | 'email'
  | 'existing_account'
  | 'facebook'
  | 'google';

export type RegistrationElement = 'method' | 'set_password' | 'start';

export type RegistrationTargetProperties = Partial<ModalProperties> & {
  element: RegistrationElement;
  method?: RegistrationMethod;
  placement: RegistrationPlacement;
  product_id?: string;
};

type EventData = {
  element?: RegistrationElement;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  method?: RegistrationMethod;
  modal?: ModalScreen;
  placement: RegistrationPlacement;
  productId?: string;
};

class RegistrationInteractionEvent extends InteractionEvent<
  EventData,
  RegistrationTargetProperties
> {
  protected get keepalive(): boolean {
    return true;
  }

  protected get targetType(): InteractionTargetType {
    return 'registration';
  }

  protected getTargetProperties(): RegistrationTargetProperties {
    const { element, method, modal, placement, productId } = this.data;

    return {
      ...(modal && toModalProperties(modal)),
      element: element ?? (method ? 'method' : 'start'),
      method,
      placement,
      product_id: productId
    };
  }
}

export default RegistrationInteractionEvent;
